import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';

const postAnnShipShipment = createAsyncThunk('annShipShipment/postAnnShipShipment',
  async (formData, { rejectWithValue }) => {
    try {
      const data = await authSet(METHOD_POST, '/shipping/annship', formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postAnnShipShipment;
